(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/sport/result-boxes/assets/javascripts/models/distribution-model.js') >= 0) return;  svs.modules.push('/components/sport/result-boxes/assets/javascripts/models/distribution-model.js'); 
'use strict';

svs.sport.result_boxes.models.Distribution = Backbone.Model.extend({
  log: new svs.core.log.Logger('svs.sport.result_boxes.models.Distribution'),

  initialize: function() {
    this.set({
      distributionHeadline: this.getHeadLine(),
      showOdds: this.getShowOdds()
    });
    this.listenTo(this.get('model'), 'change', this.handleChange);
  },

  handleChange: function(newData) {
    if (!this.get('payouts') || this.get('payouts') !== newData.payouts) {
      this.set('payouts', newData.payouts);
    }

    if (
      !this.get('drawStateId') ||
        this.get('drawStateId') !== newData.drawStateId
    ) {
      this.set({
        drawStateId: newData.drawStateId,
        distributionHeadline: this.getHeadLine
      });
    }
  },

  getHeadLine: function() {
    var drawIsLive =
          this.get('drawStateId') >=
            svs.sport.result_boxes.constants.CANCELCLOSED &&
          this.get('drawStateId') < svs.sport.result_boxes.constants.FINALIZED,
      headLine = drawIsLive ? 'Aktuell utdelning ' : 'Utdelning ';
    headLine = headLine + 'för Svenska folket';
    return headLine;
  },

  getShowOdds: function() {
    var showOdds = false;
    if (
      this.get('productName').toLowerCase() ===
          svs.sport.result_boxes.constants.productName.BOMBEN ||
        this.get('productName').toLowerCase() ===
          svs.sport.result_boxes.constants.productName.POWERPLAY ||
        this.get('productName').toLowerCase() ===
          svs.sport.result_boxes.constants.productName.CHALLENGE
    ) {
      showOdds = true;
    }
    return showOdds;
  }
});

 })(window);